

import { IUser } from '@clickster/constant-definitions/dist-esm/entities/user/types';
import { StateCreator, create } from 'zustand';

export interface UserStore {
  userInSession?: IUser | null;
  isLoadingUser: boolean;
  showAuthModal: boolean;
}

export const createUserStore: StateCreator<UserStore> = (set) => {
  // DEPRECATED: localStorage token check - now using HTTP-only cookies only
  // const hasToken = typeof localStorage !== 'undefined' && !!localStorage.getItem('clk-token');

  return {
    /* INITIAL STATE */
    userInSession: null, // Explicitly null instead of undefined for consistency
    isLoadingUser: false, // If there's a token, indicate we're loading
    showAuthModal: false,
  };
};

export const useClicksterStore = create<UserStore>(createUserStore);
